<template lang="pug">
  el-card(shadow="hover",v-if="dadosCartorioAutopreenchidos").card-container
    validation-observer(ref='validation' tag='form')
      form(@submit.prevent="onSubmit")
        app-divider.mb-20(label='Interessado')

        el-row.mb-20(type="flex", :gutter="40")
          el-col
            validation-provider(rules="notZero", v-slot="{ errors }")
              app-label(label="Nome do interessado:")
              el-input.input(
                :value='dadosCartorioAutopreenchidos.nomeInteressado',
                v-model='dadosCartorioManuais.nomeInteressado'
                :disabled='dadosCartorioAutopreenchidos.nomeInteressado !== null'
              )
              span.help.erro {{ errors[0] }}
          el-col
            app-label(label="CPF:")
            el-input.input(
              :value='dadosCartorioAutopreenchidos.cpfInteressado',
              v-model='dadosCartorioManuais.cpfInteressado',
              :disabled='dadosCartorioAutopreenchidos.cpfInteressado !== null'
            )
          el-col
            app-label(label="RG:")
            el-input.input(
              :value='dadosCartorioAutopreenchidos.rgInteressado',
              v-model='dadosCartorioManuais.rgInteressado',
              :disabled='dadosCartorioAutopreenchidos.rgInteressado !== null'
            )
        el-row.mb-20(type="flex", :gutter="40")
          el-col
            app-label(label="Data de nascimento:")
            el-date-picker.input.full-width(
              :picker-options='options',
              v-model='dadosCartorioManuais.dataNascimentoInteressado'
              format="dd/MM/yyyy",
              v-mask="'##/##/#####'"
              :disabled='dadosCartorioAutopreenchidos.dataNascimentoInteressado'
            )
          el-col
            app-label(label="Telefone:")
            el-input.input(
              :value='dadosCartorioAutopreenchidos.telefoneInteressado',
              v-model='dadosCartorioManuais.telefoneInteressado',
              :disabled='dadosCartorioAutopreenchidos.telefoneInteressado !== null'
            )
          el-col
            app-label(label="Profissão:")
            el-input.input(
              :value='dadosCartorioAutopreenchidos.profissaoInteressado',
              v-model='dadosCartorioManuais.profissaoInteressado',
              :disabled='dadosCartorioAutopreenchidos.profissaoInteressado !== null'
            )
        el-row.mb-20(type="flex", :gutter="40")
          el-col
            app-label(label="Nome da mãe:", :required="false")
            el-input.input(
              v-model='dadosCartorioManuais.nomeDaMae'
            )
          el-col
            app-label(label="Nome do pai:", :required="false")
            el-input.input(
              v-model='dadosCartorioManuais.nomeDoPai'
            )
          el-col
            app-label(label="Estado civil:")
            el-select.input.full-width(
              class="select",
              name='Estado civil'
              value-key="codigo"
              clearable,
              filterable,
              v-model='dadosCartorioManuais.estadoCivil',
            )
              el-option(
                v-for="estado in estadosCivil",
                :key="estado.codigo",
                :label="estado.nome",
                :value="estado.nome"
              )
        el-row.mb-20(type="flex", :gutter="40")
          el-col(:span="8")
            app-label(label="Data de casamento:", :required="false")
            el-date-picker.input.full-width(
              v-model='dadosCartorioManuais.dataCasamento',
              format="dd/MM/yyyy",
              v-mask="'##/##/#####'"
            )

        app-divider.mb-20(label='Cônjuge/Companheiro(a)')

        div(v-if="dadosCartorioAutopreenchidos.hasConjuge")
          el-row.mb-20(type="flex", :gutter="40")
            el-col
              app-label(label="Nome do cônjuge/companheiro(a):")
              el-input.input(
                :value='dadosCartorioAutopreenchidos.nomeConjuge',
                v-model='dadosCartorioManuais.nomeConjuge',
                :disabled='dadosCartorioAutopreenchidos.nomeConjuge !== null'
              )
            el-col
              app-label(label="CPF do cônjuge/companheiro(a):")
              el-input.input(
                :value='dadosCartorioAutopreenchidos.cpfConjuge',
                v-model='dadosCartorioManuais.cpfConjuge',
                :disabled='dadosCartorioAutopreenchidos.cpfConjuge !== null'
              )
            el-col
              app-label(label="RG do cônjuge/companheiro(a):")
              el-input.input(
                :value='dadosCartorioAutopreenchidos.rgConjuge',
                v-model='dadosCartorioManuais.rgConjuge',
                :disabled='dadosCartorioAutopreenchidos.rgConjuge !== null'
              )
          el-row.mb-20(type="flex", :gutter="40")
            el-col(:span="8")
              app-label(label="Profissão do cônjuge/companheiro(a):")
              el-input.input(
                :value='dadosCartorioAutopreenchidos.profissaoConjuge',
                v-model='dadosCartorioManuais.profissaoConjuge',
                :disabled='dadosCartorioAutopreenchidos.profissaoConjuge !== null'
              )
        div(v-else)
          app-display(label="Possui cônjuge/companheiro(a)?", content="Não")

        app-divider.mb-20(label='Imóvel')

        el-row.mb-20(type="flex", :gutter="40")
          el-col
            app-label(label="Endereço:")
            el-input.input(
              :value='dadosCartorioAutopreenchidos.endereco',
              v-model='dadosCartorioManuais.endereco',
              :disabled='dadosCartorioAutopreenchidos.endereco !== null'
            )
          el-col
            app-label(label="Nº do imóvel:")
            el-input.input(
              :value='dadosCartorioAutopreenchidos.numeroImovel',
              v-model='dadosCartorioManuais.numeroImovel',
              :disabled='dadosCartorioAutopreenchidos.numeroImovel !== null'
            )
          el-col
            app-label(label="Bairro:")
            el-input.input(
              :value='dadosCartorioAutopreenchidos.bairro',
              v-model='dadosCartorioManuais.bairro',
              :disabled='dadosCartorioAutopreenchidos.bairro !== null'
            )
        el-row.mb-20(type="flex", :gutter="40")
          el-col
            app-label(label="Lote:")
            el-input.input(
              :value='dadosCartorioAutopreenchidos.lote',
              v-model='dadosCartorioManuais.lote',
            )
          el-col
            app-label(label="Quadra:")
            el-input.input(
              :value='dadosCartorioAutopreenchidos.quadra',
              v-model='dadosCartorioManuais.quadra',
            )
          el-col
            app-label(label="IPTU:")
            el-input.input(
              v-model='dadosCartorioManuais.iptu',
            )

        app-divider.mb-20(label='')

        el-row.mb-20(type="flex", :gutter="40")
          el-col
            app-label(label="Descrição/Memorial: ")
            el-input.input(
              type='textarea',
              :rows='5',
              placeholder='Digite o texto...',
              :value='dadosCartorioAutopreenchidos.descricaoMemorial'
              v-model='dadosCartorioManuais.descricaoMemorial',
              maxlength='500',
              show-word-limit
            )
    app-buttons-cadastro(
      :isUltimoPasso="true",
      :isPrimeiroPasso="true",
      :showButtonSalvar="true",
      :showButtonCancelar="true"
      :showButtonFinalizar="false"
      @cancelar="cancelar"
      @salvar="salvar"
    )
</template>

<script>
import { mapActions } from 'vuex'
import AppLabel from '@/components/AppLabel'
import AppDivider from '@/components/AppDivider'
import AppDisplay from '@/components/AppDisplay'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import _ from 'lodash'
import moment from 'moment'
const { estadosCivil } = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppLabel,
    AppDivider,
    AppDisplay,
    AppButtonsCadastro
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      dadosCartorioAutopreenchidos: null,
      dadosCartorioManuais: null,
      options: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      estadosCivil
    }
  },

  props: {
    idProcesso: {
      required: true
    }
  },

  async mounted () {
    this.dadosCartorioAutopreenchidos = await this.getDadosEnviarCartorio(this.idProcesso)
    this.dadosCartorioManuais = _.cloneDeep(this.dadosCartorioAutopreenchidos)
    this.dadosCartorioManuais = {
      ...this.dadosCartorioManuais,
      dataNascimentoInteressado: this.dadosCartorioManuais.dataNascimentoInteressado ? moment(this.dadosCartorioManuais.dataNascimentoInteressado, 'DD/MM/yyyy').toDate() : null,
      dataCasamento: this.dadosCartorioManuais.dataCasamento ? moment(this.dadosCartorioManuais.dataCasamento, 'DD/MM/yyyy').toDate() : null
    }
  },

  methods: {
    ...mapActions({
      getDadosEnviarCartorio: 'processo/getDadosEnviarCartorio',
      saveDadosCartorio: 'despacho/saveDadosCartorio'
    }),
    async salvar () {
      this.dadosCartorioManuais = {
        ...this.dadosCartorioManuais,
        idProcesso: this.idProcesso
      }
      await this.saveDadosCartorio(this.dadosCartorioManuais).then(() => {
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.DADOS_SALVOS_SUCESSO)
        this.$router.back()
      })
    },
    cancelar () {
      this.$router.push({
        name: 'AGUARDANDO_ENVIO_CARTORIO'
      })
    }
  }

}
</script>

<style scoped lang="scss">
.card-container {
  margin: 20px;
  border-radius: 10px;
}
.mb-20 {
  margin-bottom: 20px;
}
.full-width {
  width: -webkit-fill-available;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/InserirDadosCartorio.vue